import React from "react";
import Plot from "react-plotly.js";

const LCOEPlot = () => {
  const years = [
    2009, 2010, 2011, 2012, 2013, 2014, 2015,
    2016, 2017, 2018, 2019, 2020, 2021,
    2023, 2024, 2025
  ];
  const hover = "%{x}, $%{y}/kWh";
  const data = [
    {
  name: "Ideal Nuclear",
  y: [0.052],
  x: [2025],
  type: "scatter",
  mode: "markers",
  marker: {
    size: 14,
    color: "red",
    symbol: "circle"
  },
  hovertemplate: hover
}
,
    {
      name: "Nuclear-U.S.",
      y: [123, 96, 95, 96, 104, 112, 117, 117, 148, 151, 155, 163, 167, 180, 182, 180].map(val => val / 1000),
      x: years,
      type: "scatter",
      mode: "lines+markers",
      hovertemplate: hover
    },
    {
      name: "Coal",
      y: [111, 111, 111, 102, 105, 109, 108, 102, 102, 102, 109, 112, 108, 117, 118, 122].map(val => val / 1000),
      x: years,
      type: "scatter",
      mode: "lines+markers",
      hovertemplate: hover
    },
    {
      name: "Gas Peaking",
      y: [275, 243, 227, 216, 205, 205, 192, 191, 183, 179, 175, 175, 173, 168, 169, 200].map(val => val / 1000),
      x: years,
      type: "scatter",
      mode: "lines+markers",
      hovertemplate: hover
    },
    {
      name: "Gas Combined Cycle",
      y: [83, 82, 83, 75, 74, 74, 65, 63, 60, 58, 56, 59, 60, 70, 76, 78].map(val => val / 1000),
      x: years,
      type: "scatter",
      mode: "lines+markers",
      hovertemplate: hover
    },
    {
      name: "Geothermal",
      y: [76, 107, 104, 116, 116, 116, 100, 98, 97, 91, 91, 80, 75, 82, 85, 88].map(val => val / 1000),
      x: years,
      type: "scatter",
      mode: "lines+markers",
      hovertemplate: hover
    },
    {
      name: "Wind Onshore",
      y: [135, 124, 71, 72, 70, 59, 55, 47, 45, 42, 41, 40, 38, 50, 50, 61].map(val => val / 1000),
      x: years,
      type: "scatter",
      mode: "lines+markers",
      hovertemplate: hover
    },
    {
      name: "Solar PV",
      y: [359, 248, 157, 125, 98, 79, 65, 55, 50, 43, 40, 37, 36, 60, 61, 58].map(val => val / 1000),
      x: years,
      type: "scatter",
      mode: "lines+markers",
      hovertemplate: hover
    }
  ];

  return (
    <Plot
      data={data}
      layout={{

        title: "LCOE Comparison by Energy Source (2009–2025)",
        xaxis: { title: "Year", fixedrange: true },
        yaxis: { title: "LCOE ($/kWh)", fixedrange: true },
        legend: { orientation: "h" },
        autosize: true,
        margin: { t: 50, b: 50, l: 50, r: 50 },
        }}
      useResizeHandler={true}
  style={{ width: "100%", height: "100%" }}
  config={{ displayModeBar: false, scrollZoom: false }}
    />
  );
};

export default LCOEPlot;
